import {
    RegionsEnum, ValvesFilterPageAmDocument,
    ValvesFilterPageApDocument,
    ValvesFilterPageDocument,
    ValvesFilterPageEuDocument,
    ValvesPageAmDocument, ValvesPageAmQuery, ValvesPageAmQueryVariables,
    ValvesPageApDocument, ValvesPageApQuery, ValvesPageApQueryVariables,
    ValvesPageEuDocument, ValvesPageEuQuery, ValvesPageEuQueryVariables, VssValveAmFragmentDoc, VssValveEuFragmentDoc,
} from 'src/generated/operations.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { DocumentNode } from 'graphql/language/ast';
import { generateFiltersConfig } from 'src/utils/generateFiltersConfig.ts';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { getHomePageConfig } from 'src/modules/home/HomePageMapping.ts';
import { generateItemsConfig } from 'src/utils/generateOrderItems.ts';

export type ValvesPageData = Omit<ValvesPageEuQuery | ValvesPageApQuery | ValvesPageAmQuery, '__typename'>;
export type ValvesPageVariables = Omit<
ValvesPageEuQueryVariables | ValvesPageApQueryVariables | ValvesPageAmQueryVariables, '__typename'
>;
export type ValveProduct = ValvesPageData['list']['products']['0']['product'];

export type ValvesPageConfig = {
    mainFilterConfig: FilterConfig;
    query: DocumentNode;
    filterConfig: FilterConfig;
    orderItemsConfig: FilterConfig;
    genericFilterQuery: DocumentNode;
}

export const getValvesPageConfig = (region: RegionsEnum): ValvesPageConfig | null => {
    const homePageConfig = getHomePageConfig(region);
    if (homePageConfig === null) {
        throw new Error('No Home Page Config');
    }
    const genericFilterQuery = removeDuplicateFragments(ValvesFilterPageDocument);
    const mainFilterConfig = homePageConfig.filterConfig;
    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(ValvesPageEuDocument),
            filterConfig: generateFiltersConfig(ValvesFilterPageEuDocument, 'vssValues'),
            orderItemsConfig: generateItemsConfig(VssValveEuFragmentDoc),
            mainFilterConfig,
            genericFilterQuery,
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(ValvesPageApDocument),
            filterConfig: generateFiltersConfig(ValvesFilterPageApDocument, 'vssValues'),
            orderItemsConfig: generateItemsConfig(VssValveEuFragmentDoc),
            mainFilterConfig,
            genericFilterQuery,
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(ValvesPageAmDocument),
            filterConfig: generateFiltersConfig(ValvesFilterPageAmDocument, 'vssValues'),
            orderItemsConfig: generateItemsConfig(VssValveAmFragmentDoc),
            mainFilterConfig,
            genericFilterQuery,
        };
    }
    return null;
};
